import React from 'react';
import './GameOver.css';

const GameOver = ({ score, highScore, onRestart, onMainMenu }) => {
  // 새 최고 점수인지 확인
  const isNewHighScore = score >= highScore;

  return (
    <div className="game-over">
      <h1>게임 종료!</h1>
      
      <div className="final-score">
        <p>최종 점수: <span className="score-value">{score}</span></p>
        <p>최고 점수: <span className="score-value">{highScore}</span></p>
        
        {isNewHighScore && (
          <div className="new-high-score">
            🎉 새로운 최고 점수! 🎉
          </div>
        )}
      </div>
      
      <div className="game-over-buttons">
        <button className="restart-button" onClick={onRestart}>
          다시 시작
        </button>
        <button className="main-menu-button" onClick={onMainMenu}>
          메인 메뉴
        </button>
      </div>
      
      <div className="share-section">
        <p>친구들과 공유하기:</p>
        <div className="share-buttons">
          <button className="share-button" onClick={() => alert('공유 기능은 실제 배포 시 활성화됩니다.')}>
            공유하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOver;
